const AUTH0_AUDIENCE_URL_PREFIX = "VITE_AUTH0_AUDIENCE_URL_";

export function handleEnvVars(env: Record<string, string>) {
  const VALID_MOCK_MODES = ["full", "mixed", "demo"] as const;
  type MockMode = (typeof VALID_MOCK_MODES)[number];
  const mockMode = VALID_MOCK_MODES.includes(env.VITE_MOCK_MODE as MockMode)
    ? (env.VITE_MOCK_MODE as MockMode)
    : undefined;
  const devToken = env.VITE_DEV_TOKEN || undefined;
  const devCredentials = env.VITE_DEV_CREDENTIALS || undefined;
  const isProxied = env.VITE_IS_PROXIED || "false";
  // DEMO: "demo" runs the same fully-mocked stack as "full" (no auth0), only
  // serving the curated demo dataset instead of the randomised mocks.
  const isFullyMocked = mockMode === "full" || mockMode === "demo";
  const requiresAuth0 = !devToken && !devCredentials && !isFullyMocked;

  const buildVariant = env.VITE_BUILD_VARIANT || "platform";

  const buildFeatureSet = env.VITE_BUILD_FEATURE_SET || "default";
  const auth0Domain = env.VITE_AUTH0_DOMAIN || "";

  const apiBaseUrl =
    env[`VITE_API_BASE_URL_${buildVariant}`] || env.VITE_API_BASE_URL;
  const auth0ClientId = env[`VITE_AUTH0_CLIENT_ID_${buildVariant}`] || "";
  const auth0Audience =
    env[`VITE_AUTH0_AUDIENCE_URL_${buildVariant}`] ||
    env.VITE_AUTH0_AUDIENCE_URL ||
    env.VITE_AUTH0_AUDIENCE ||
    "";

  const auth0Audiences = Object.fromEntries(
    Object.entries(env)
      .filter(
        ([key, value]) =>
          key.startsWith(AUTH0_AUDIENCE_URL_PREFIX) && Boolean(value),
      )
      .map(([key, value]) => [
        key.slice(AUTH0_AUDIENCE_URL_PREFIX.length),
        value,
      ]),
  );

  const auth0CallbackUrl = env.VITE_AUTH0_CALLBACK_URL || "/callback";
  const auth0Scopes = `openid profile email ${env[`VITE_AUTH0_SCOPE_${buildVariant}`] || "VIEW_ALL UPDATE_ALL CREATE_ALL"}`;

  if (!env.PROD) {
    console.debug("devToken: ", devToken);
    console.debug("devCredentials: ", devCredentials);
    console.debug("apiBaseUrl: ", apiBaseUrl);
    console.debug("auth0Audience: ", auth0Audience);
    console.debug("auth0Audiences: ", auth0Audiences);
    console.debug("auth0Domain: ", auth0Domain);
    console.debug("buildVariant: ", buildVariant);
    console.debug("buildFeatureSet: ", buildFeatureSet);
    console.debug("auth0ClientId: ", auth0ClientId);
    console.debug("requiresAuth0: ", requiresAuth0);
  }

  const hubApps = env.VITE_HUB_APPS?.split(",");

  return {
    apiBaseUrl,
    devToken,
    devCredentials,
    isProxied,
    mockMode,
    requiresAuth0,
    auth0Domain,
    auth0ClientId,
    auth0Audience,
    auth0Audiences,
    buildVariant,
    buildFeatureSet,
    auth0CallbackUrl,
    auth0Scopes,
    hubApps,
  };
}
